import React from 'react'
import Users from '../../admin/Users'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3UsersPage() {
  return (
    <V3DataRouteShell>
      <Users visualVariant="v3" />
    </V3DataRouteShell>
  )
}

